import React from 'react';
import { isPast } from 'date-fns';

import { makeStyles } from '~/UIKit/Style';
import { useCalendarDragLayer } from './useCalendarDragLayer';
import { PositionedEvent } from '~/Screens/Calendar/CalendarView/components/PositionedEvent';
import { ICalendarOffset } from '~/Screens/Calendar/interfaces';
import { DraggableType, ICalculateNewEvent, IGetEventPosition } from './utils';
import { IEvent } from '~/Models/DTO/Event.model';

const useStyles = makeStyles(
  () => ({
    container: {
      zIndex: 100,
      position: 'absolute',
      pointerEvents: 'none',
    },
  }),
  { name: 'CalendarDragLayer' },
);

interface ICalendarDragLayer {
  offset: ICalendarOffset;
  calendarType: DraggableType;
  getEventPosition: IGetEventPosition;
  calculateNewEvent?: (props: ICalculateNewEvent) => IEvent;
}

export const CalendarDragLayer = ({
  offset,
  getEventPosition,
  calendarType,
  calculateNewEvent,
}: ICalendarDragLayer) => {
  const { classes } = useStyles();
  const { eventPosition, isDragging, newEvent, itemType } = useCalendarDragLayer({
    calculateNewEvent,
    offset,
    calendarType,
    getEventPosition,
  });

  if (!isDragging || calendarType !== itemType) {
    return null;
  }

  return (
    <div className={classes.container} style={offset}>
      {newEvent && eventPosition && (
        <PositionedEvent
          event={newEvent}
          isPast={isPast(Date.parse(newEvent.start))}
          position={eventPosition}
        />
      )}
    </div>
  );
};
